import * as ls from '@/services/localStorage';
import { List } from 'immutable';
import { trackLoginEvent } from 'nike-ui/src/analytics/events/user';

export function initOncePerLogin(db) {
    const KEY = 'nike.scheduledOncePerLogin';
    if (!db.get('loggedIn')) {
        ls.setObject(KEY, 1);
        return db;
    }
    const scheduled = (ls.getObject(KEY) || 0) === 1;
    if (scheduled) {
        db = doOncePerLogin(db);
        ls.removeKey(KEY);
    }
    return db;
}

function doOncePerLogin(db) {
    trackLoginEvent();
    // ziadne popupy ak ma user vynutenu zmenu hesla
    if (db.getIn(['account', 'userData', 'forceChangePassword'])) {
        return db;
    }

    // ziadne popupy ak ideme na doregistraciu
    const forcedActions = db.getIn(['account', 'userData', 'forcedActions'], List());
    const forcedStateRequired = forcedActions.map(step => step.get('state')).includes('required');
    if (forcedStateRequired) {
        return db;
    }

    return db;
}
